module.exports = __webpack_public_path__ + "static/img/10.8cc1d61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/10.svg
// module id = 1HfB
// module chunks = 0